import React, { useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { CurrencyAccountSelect } from '@/features/account-select';
import { PaymentMethodSelect } from '@/features/payment-method-select';

import { useAccountStore } from '@/entities/currency-account/model/store.ts';

import { AMOUNT_REGEXP } from '@/shared/lib';
import {
  AmountWithFeeAutosizeInput,
  ArrowOpener,
  Button,
  Typography,
} from '@/shared/ui';

import { useAddMoney } from '../../../model/useAddMoney.ts';

export const AddMoneyContent = () => {
  const {
    setStep,
    setAmount,
    amount,
    fee,
    account,
    setAccount,
    paymentMethod,
    setPaymentMethod,
  } = useAddMoney(useShallow((state) => state));
  const { account: defaultAcc } = useAccountStore();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (AMOUNT_REGEXP.test(newValue)) {
      setAmount(newValue === '' ? 0 : parseFloat(newValue));
    }
  };
  const handleContinue = () => {
    if (amount !== 0) {
      setStep('card');
    }
  };
  useEffect(() => {
    setAccount(account ?? defaultAcc);
  }, []);
  return (
    <div className="relative flex h-[528px] w-full flex-col items-center">
      <AmountWithFeeAutosizeInput
        currencySymbol={account?.symbol}
        amount={amount}
        fee={fee}
        onChange={handleChange}
        className="mx-auto mt-[52px] py-[129px]"
      />
      <div className="absolute top-0 flex flex-col gap-1 py-1 text-center">
        {account && (
          <>
            <CurrencyAccountSelect
              selected={account}
              onSelect={setAccount}
              customTrigger={
                <ArrowOpener>{`To ${account.code} account`}</ArrowOpener>
              }
              excludeAllAccounts
            />
            <Typography variant="14-r" color="text-base-100">
              Balance: {account.value}&#8239;{account.symbol}
            </Typography>
          </>
        )}
      </div>
      <div className="absolute bottom-0 flex w-full flex-col gap-1">
        <PaymentMethodSelect onSelect={setPaymentMethod} type={paymentMethod} />
        <Button size="lg" onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
};
